import { createSlice } from '@reduxjs/toolkit'

// `name: 'modals'` plus these reducer keys regenerate the exact existing action
// strings `modals/SHOW_HOTKEYS_MODAL` / `modals/HIDE_HOTKEYS_MODAL` (see ./types),
// so operations.js, selectors.js and all callers keep working unchanged. Keep the
// slice name and reducer keys verbatim — they are the action-type wire format.
// Immer lets each case mutate the draft state directly.
const hotkeys = createSlice({
  name: 'modals',
  initialState: { visible: false },
  reducers: {
    SHOW_HOTKEYS_MODAL: draftState => {
      draftState.visible = true
    },
    HIDE_HOTKEYS_MODAL: draftState => {
      draftState.visible = false
    },
  },
})

export default hotkeys.reducer
